import { ID } from '../types/models/id.model'

const CITY_URL_PREFIX = '-airport-taxi'

export const ROUTES = {
  home: '/',
  contactUs: '/contact-us',
  provider: '/provider',
  city: (slug: string) =>
    slug.toLowerCase().endsWith(CITY_URL_PREFIX)
      ? `/${slug}`
      : `/${slug}${CITY_URL_PREFIX}`,
  helpCenter: '/help/center',
  helpFaq: '/help/faq',
  login: '/auth/login',
  verify: '/auth/verify',
  about: '/about-us',
  blog: '/blog',
  headline: (slug: string) => `/blog/${slug}`,
  post: (slug: string) => `/blog/post/${slug}`,
  support: '/profile/support',
  terms: '/terms-and-conditions',
  privacy: '/privacy-policy',
  tel: (phone: string) => `tel:${phone}`,
  mail: (email: string) => `mailto:${email}`,

  profile: '/profile',
  chats: '/chats',
  chat: (chatId: string | number | undefined) =>
    chatId ? `/chats/${chatId}` : '',
  trips: '/trips',
  tripHistory: '/profile/trip-history',
  wallet: '/profile/wallet',
  tripHistoryDetails: (id: ID) => `/profile/trip-history/${id}`,
  upcomingTripDetails: (id: ID) => `/trips/${id}`,
  profileSettings: '/profile/settings',
  whatsApp: (phoneNumber: string | undefined) => {
    if (!phoneNumber) return ''
    return `https://wa.me/${phoneNumber.replaceAll(/[+\s]/g, '')}`
  },
  prev: './',
  searchParam: ({ name, value }: { name: string; value: string }) =>
    `?${name}=${value}`,
  reservationRoot: '/reservation',
  reservation: '/reservation/booking-details',
  payTrip: (tripId: ID) => `/reservation/${tripId}/pay`,
  tripPaymentSucceed: (tripId: ID) => `/reservation/${tripId}/payment-succeed`,
  tripPaymentFailed: (tripId: ID) => `/reservation/${tripId}/payment-failed`,

  updateTrip: (id: ID) => `/trips/${id}/update`,
  updateTripBookingDetails: (id: ID) => `/trips/${id}/update/booking-details`,
  updateTripPay: (id: ID) => `/trips/${id}/update/pay`,
  updateTripPaymentSucceed: (id: ID) => `/trips/${id}/update/payment-succeed`,
  updateTripPaymentFailed: (id: ID) => `/trips/${id}/update/payment-failed`,
} as const

export const PROVIDER_ROUTES = {
  base: '/provider',
  login: '/provider/auth/login',
  createAccount: '/provider/auth/create-account',
  verifyAccount: '/provider/auth/verify-account',
  forgotPassword: '/provider/auth/forgot-password',
  resetPassword: '/provider/auth/reset-password',
  bankInformation: '/provider/profile/bank-information',
  companyRegistration: '/provider/profile/company-registration',
  editProfile: '/provider/profile',
  settings: '/provider/profile/settings',
  reservation: '/provider/reserve-trip',
  reservationBookingDetails: '/provider/reserve-trip/booking-details',
  reservationPay: (tripId: ID) => `/provider/reserve-trip/${tripId}/pay`,
  reservationPaymentSucceed: (tripId: ID) =>
    `/provider/reserve-trip/${tripId}/payment-success`,
  reservationPaymentFailed: (tripId: ID) =>
    `/provider/reserve-trip/${tripId}/payment-failed`,

  updateTrip: (tripId: ID) => `/provider/trips/${tripId}/update`,
  updateTripBookingDetails: (tripId: ID) =>
    `/provider/trips/${tripId}/update/booking-details`,
  updateTripPay: (tripId: ID) => `/provider/trips/${tripId}/update/pay`,
  updateTripPaymentSucceed: (tripId: ID) =>
    `/provider/trips/${tripId}/update/payment-success`,
  updateTripPaymentFailed: (tripId: ID) =>
    `/provider/trips/${tripId}/update/payment-failed`,
  tripHistory: '/provider/trip-history',
  tripHistoryDetails: (tripId: ID) => `/provider/trip-history/${tripId}`,
  trips: '/provider/trips',
  upcomingTripDetails: (tripId: ID) => `/provider/trips/${tripId}`,
} as const

export const QUERY_ROUTES = {
  login: { name: 'auth', value: 'login' },
  verify: { name: 'auth', value: 'verify' },
  cancelTrip: { name: 'action', value: 'cancel' },
  tripPayment: (id: string) => ({ name: 'trip-id', value: id }),
  tripPaymentStatus: (status: string) => ({ name: 'payment', value: status }),
  sendVerificationCode: { name: 'auth', value: 'send-verification-code' },
  verifyPhone: { name: 'auth', value: 'verify-account' },
  returnTo: { name: 'return-to', value: (path: string) => path },
} as const
